(function ($) {
	// トップページへのお知らせの表示と表示件数
	$.ajax({
		url: "news", //読み込むファイルを指定
		cache: false, //キャッシュを保存するかの指定
		success: function (html) {
			//データ取得後に実行する処理
			$(html)
				.find("#newslist")
				.each(function () {
					//読み込みたい部分の指定
					$("#top-newslist").html($(this).html()); //読み込んだ外部HTMLを表示する領域を指定
					return false;
				});
			$("#top-newslist .news-item:gt(2)").remove(); //3件目以降の article を削除
		},
	});
})(jQuery);
